import React from 'react';
import { ISandboxProvider } from './../../../interfaces/service/SandboxServiceManagerInterface';
import { MultiSelectComponent } from '../../../components/MultiSelectComponent';
import { InputComponent } from '../../../components/InputComponent';
import { ButtonComponent } from '../../../components/ButtonComponen';
import { IoIosSearch } from 'react-icons/io';
import { TbFilterOff } from 'react-icons/tb';
import { RiFileExcel2Line } from 'react-icons/ri';
import { defaultColumnsSandboxTable } from './utils';
interface FilterSandBoxProps {
  service: ISandboxProvider;
}

// Componente React válido
export const FilterSandbox: React.FC<FilterSandBoxProps> = ({ service }) => {
  const dualTextTemplate = (option: any) => {
    return (
      <div>
        <span className="text-grey">({option.code}) </span>
        <span>{option.name}</span>
      </div>
    );
  };

  const renderSelectOperators = () => {
    return (
      <div className="w-[15%] mx-1">
        <MultiSelectComponent
          options={service.filterOptions.operatorsList}
          optionLabel={'name'}
          placeholder="Operadores tecnológicos"
          name="operatorsValueSelected"
          value={service.filtersData.operatorsValueSelected}
          className="h-12"
          onChange={service.onChangeFilterData}
          max={2}
          selectedItemsLabel="Seleccionar columnas"
        />
      </div>
    );
  };

  const renderSelectProjects = () => {
    return (
      <div className="w-[15%] mx-1">
        <MultiSelectComponent
          options={service.filterOptions.projectsList}
          optionLabel={'name'}
          placeholder="Proyectos"
          name="projectValueSelected"
          value={service.filtersData.projectValueSelected}
          className="h-12"
          onChange={service.onChangeFilterData}
          max={2}
          selectedItemsLabel="Seleccionar columnas"
        />
      </div>
    );
  };

  const renderSelectSamTypes = () => {
    return (
      <div className="w-[15%] mx-1">
        <MultiSelectComponent
          options={service.filterOptions.samTypeList}
          optionLabel={'name'}
          placeholder="Tipos de SAM"
          name="samValueSelected"
          value={service.filtersData.samValueSelected}
          className="h-12"
          onChange={service.onChangeFilterData}
          max={2}
          itemTemplate={dualTextTemplate}
          selectedItemsLabel="Seleccionar columnas"
        />
      </div>
    );
  };

  const renderFindSearch = () => {
    return (
      <div className="w-[15%] mx-1">
        <InputComponent
          type={'text'}
          name={'samIdValue'}
          className={'h-12'}
          value={service.filtersData.samIdValue}
          onChange={service.onChangeFilterData}
          placeholder="Filtrar por SAM ID"
          classSpan={'p-input-icon-right'}
        />
      </div>
    );
  };

  const buttonsActions = () => {
    return (
      <div className="flex w-full h-full col-span-2 col-start-6 justify-end items-center gap-2 px-3">
        <MultiSelectComponent
          options={defaultColumnsSandboxTable}
          optionLabel={'header'}
          placeholder="Seleccionar columnas"
          value={service.columnsSelected}
          className="  !w-1/3"
          onChange={service.handleSelectColumn}
          selectedItemsLabel="Seleccionar columnas"
        />
        <ButtonComponent
          icon={<IoIosSearch />}
          onClick={service.onClickSendData}
          className="p-button-rounded  p-button-md"
          name="search"
        />

        <ButtonComponent
          icon={<RiFileExcel2Line />}
          onClick={service.onExportExcel}
          className="p-button-rounded p-button-md"
          name="export"
        />
      </div>
    );
  };

  return (
    <div className="flex w-[100%] items-center">
      {renderSelectOperators()}
      {renderSelectProjects()}
      {renderSelectSamTypes()}

      {renderFindSearch()}
      {buttonsActions()}
      {/* {renderButtonSendData()} */}
    </div>
  );
};
